export default "__VITE_ASSET__f8ecf620__"